import { z } from "zod";

import {
  KnownMcpVendorLiteral,
  SupportedMcpServerLiteral,
} from "../../../mcp-client";
import { ParameterInputTypeLiteral } from "../../../parameterType.js";

/**
 * Chart/visualization icon types
 */
export const ChartIconLiteral = z.enum([
  "pivot-table",
  "sankey",
  "line",
  "area",
  "area_stacked",
  "area_stacked100",
  "scatter",
  "pie",
  "bar_grouped",
  "bar_stacked",
  "bar_stacked100",
  "column_grouped",
  "column_stacked",
  "column_stacked100",
  "combo",
  "histogram",
]);
export type ChartIcon = z.infer<typeof ChartIconLiteral>;

/**
 * Determines which icon will be shown on the tool call in the UI.
 */
export const ToolIconLiteral = z.union([
  z.literal("database"),
  z.literal("search"),
  z.literal("loading"),
  z.literal("lightbulb"),
  z.literal("task"),
  z.literal("error"),
  z.literal("markdown"),
  z.literal("section"),
  z.literal("sql"),
  z.literal("python"),
  z.literal("warning"),
  z.literal("project"),
  z.literal("success"),
  z.literal("semantic-dataset"),
  z.literal("run"),
  z.literal("move"),
  z.literal("metric"),
  z.literal("filter"),
  z.literal("sort"),
  z.literal("attachment"), // deprecated, use "image" or "document" instead
  z.literal("image"),
  z.literal("document"),
  z.literal("chart_cell"),
  z.literal("git-repo"),
  z.literal("github-repo"),
  z.literal("gitlab-repo"),
  z.literal("application"),
  z.literal("console"),
  z.literal("flag"),
  z.literal("memory"),
  z.literal("snapshot"),
  z.literal("custom-mcp"),
  z.literal("create"),
  z.literal("edit"),
  z.literal("eye"),
  z.literal("trash"),
  z.literal("duplicate"),
  z.literal("arrow-right"),
  z.literal("app"),
  ChartIconLiteral,
  ParameterInputTypeLiteral,
  SupportedMcpServerLiteral,
  KnownMcpVendorLiteral,
]);

export type ToolIcon = z.infer<typeof ToolIconLiteral>;
